import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom'
import Nav from '../components/nav'
import Footer from '../components/footer/Footer'

const ProtectedLayout = () => {
    const sideMenu = useSelector(state => state.sidebarMenu);

    return (
        <div id="main-wrapper" className={`show ${sideMenu ? 'menu-toggle' : ''}`}>
            <Nav />
            <div className="content-body" style={{ minHeight: "40vh" }}>
                <div className="container-fluid">
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    )
};

export default ProtectedLayout;